import { render, staticRenderFns } from "./UsersRightSidebar.vue?vue&type=template&id=115f7a6c&scoped=true&"
import script from "./UsersRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./UsersRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./UsersRightSidebar.vue?vue&type=style&index=0&id=115f7a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f7a6c",
  null
  
)

export default component.exports